import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import InputControls from 'components/common/InputControls'
import TimerSelector from 'components/common/TimerSelector'
import ScheduleModal from 'components/ScheduleModal'
import ModalWrapper from 'components/ModalWrapper'
import PhoneViewer from 'components/PhoneViewer'
import { Button, SelectWithLabel } from 'components/Form'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import Nixi1Spinner from 'components/Nixi1Spinner'

const scheduleMode = {
  outOfOffice : 'office',
  refundAutomatic : 'refundAutomatic',
  nightTime :'nightTime'
}

const ConfigContainer = ({
  company,
  fields,
  tag,
  title,
  subtitle,
  schedule,
  data,
  currentData,
  isPreviewMsgModalOpen,
  currentChannelPreview,
  isScheduleModalOpen,
  userStatesOptions,
  loading,
  error,
  onChange,
  setCurrentChannelPreview,
  onTogglePreviewMsgModal,
  onToggleScheduleModal,
  handleSaveSchedule
}) => (
  <>
    <div
      className='config-container'
      style={{
        gridTemplateColumns: fields.includes('preview') ? '1fr 314px' : '1fr'
      }}
    >
      <div className='config-container__content'>
        <div className='config-container__content-header'>
          {title && <h2>{title}</h2>}
          {subtitle && <strong>{subtitle}</strong>}
          {fields.includes('activation') && (
            <InputControls
              label={currentData.activation?.isActive ? I18n.t('dashboard_enabled') : I18n.t('dashboard_disabled')}
              value={data.activation?.isActive}
              onChange={value => onChange({ type: 'activation', value })}
            />
          )}
          {fields.includes('unassignOperators') && (
            <InputControls
              label={I18n.t('dashboard_unassignOperators')}
              value={data.unassignOperators?.removeAssignedOperators}
              onChange={value => onChange({ type: 'unassignOperators', value })}
            />
          )}
        </div>
        <div className='config-container__content-body'>
          {fields.includes('message') && (
            <TextEditor2
              id={`message-${tag}`}
              company={company}
              limit={0}
              placeholder={I18n.t(`configuration_messages_${tag}_messagePlaceholder`)}
              value={data.message?.contentHtml || data.message?.content}
              attachments={data.message?.attachments}
              buttons={data.message?.buttons}
              removeEmojisAndAccentsValue={data.message?.removeEmojisAndAccents}
              options={['attachments', 'buttons', 'emojis', 'preview']}
              onChange={messageData => onChange({
                type: 'message',
                value: {
                  content: messageData.value,
                  contentHtml: messageData.valueHtml,
                  buttons: messageData.buttons,
                  attachments: messageData.attachments,
                  removeEmojisAndAccents: messageData.removeEmojisAndAccents
                }
              })}
              dropZoneFilesHeight={125}
              onPreviewMsg={onTogglePreviewMsgModal}
              currentChannelPreview={currentChannelPreview}
              cleanSms
              minHeight={245}
              maxHeight={null}
              isTemplateValue
            />
          )}
          {fields.some(field => field === 'multipleSelector' || field === 'timer' || field === 'singleSelector' || field === 'schedule') && (
            <div className='config-container__content-config'>
              {fields.includes('multipleSelector') && (
                <div className='config-container__content-config-field'>
                  <label>{I18n.t('configurations_messages_statesToApply')}</label>
                  <SelectWithLabel
                    placeholder={I18n.t('dashboard_select')}
                    options={userStatesOptions}
                    value={currentData.multipleSelector}
                    selectedValues={currentData.multipleSelector}
                    onChange={value => onChange({ type: 'multipleSelector', value })}
                    multi
                    isClearable
                    isRequiredAll
                  />
                </div>
              )}
              {fields.includes('timer') && (
                <TimerSelector
                  label={tag === 'users' || tag === 'operators' ? I18n.t('dashboard_inactivityTime') : I18n.t('dashboard_send-each')}
                  value={{
                    time: data.timer?.time,
                    unit: data.timer?.unit
                  }}
                  onChange={value => onChange({ type: 'timer', value })}
                  exclude={tag === 'users'
                    ? ['seconds']
                    : tag === 'operators'
                      ? ['seconds', 'days']
                      : []
                  }
                />
              )}
              {fields.includes('singleSelector') && (
                <div className='config-container__content-config-field'>
                  <label>{I18n.t('configurations_messages_newState')}</label>
                  <SelectWithLabel
                    placeholder={I18n.t('dashboard_select')}
                    options={userStatesOptions}
                    value={currentData.singleSelector}
                    onChange={value => onChange({ type: 'singleSelector', value })}
                  />
                </div>
              )}
              {fields.includes('schedule') && (
                <div className='config-container__content-config-field  config-container__content-config-field--schedule-btn'>
                  <label>{I18n.t('dashboard_configSchedule')}</label>
                  <Button primary value={I18n.t('dashboard_schedule-text')} onClick={onToggleScheduleModal} />
                </div>
              )}
            </div>
          )}
        </div>
        {(!error?.tag || error?.tag === tag) && error?.message ? (
          <p className='message-error'>{error?.message}</p>
        ) : null}
      </div>
      {fields.includes('preview') && (
        <div className='config-container__preview'>
          <span className='config-container__preview-label'>{I18n.t('dashboard_preview')}</span>
          <div className='config-container__preview-message-container'>
            <div className='config-container__preview-message'>
              <p dangerouslySetInnerHTML={{ __html: currentData.message?.contentHtml || currentData.message?.content }}></p>
            </div>
            <div className='config-container__preview-avatar'>
              <span>A</span>
            </div>
          </div>
        </div>
      )}
      {loading && <Nixi1Spinner width='25px' height='25px' />}
    </div>
    <ModalWrapper
      isOpen={isPreviewMsgModalOpen}
      toggle={onTogglePreviewMsgModal}
      header={I18n.t('dashboard_preview')}
      body={
        <div className='modal-content'>
          <PhoneViewer
            textPreview={currentData.message?.content || currentData.message?.contentHtml ? currentData.message : data.message}
            setCurrentChannelPreview={setCurrentChannelPreview}
          />
        </div>
      }
      eventBtnTxt={I18n.t('dashboard_close')}
      eventBtn={onTogglePreviewMsgModal}
      contentClassName='modal-content-phone-preview'
    />
    {isScheduleModalOpen && schedule && (
      <div className='modal-background'>
        <ScheduleModal
          scheduleMode={scheduleMode[tag]}
          closeModal={onToggleScheduleModal}
          schedules={[schedule]}
          saveSchedules={handleSaveSchedule}
          outOfOfficeEnableHolidays
          outOfOfficeEnableEveryDay
        />
      </div>
    )}
  </>
)

export default ConfigContainer
